import { render } from "./DataFormComponent.vue?vue&type=template&id=fd15e574"
import script from "./DataFormComponent.vue?vue&type=script&lang=js"
export * from "./DataFormComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__